import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { AccordionArrow, AccordionTypeTokens, BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, CardOrientation, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackPositionType, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { activateAsset, goBack, goToFaq, goToKfs, goToStateSelectionPage, needHelp, onLoad, sendOtpForPledgeConfirm, trackInterestAndChargesCustomer } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { ConfigTokens, getAppHeader, isDarkModeTheme } from '../../../configs/config';
import { getTotalLimit } from '../portfolio/actions';
import _ from 'lodash';
import { addCommasToNumber, allowDynamicLimitFromBE, getAutoDebitDate, getContactUsDetails, getLenderIcon, getLenderInfo, getMinAllowedAmountBasedOnLender, getParameters, isMobile, roundDownToNearestHundred, showNewInterestFlow, updateApplicationContextFromApi } from '../../../configs/utils';
import { getDesiredValue } from '../portfolio_readonly/actions';
import { Platform } from 'react-native';
import { LENDER_ID } from "../../../configs/constants";
import { createProcessingChargeDS } from "./utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
const _isMobile = isMobile();
let isDarkMode = isDarkModeTheme();
export const template = async (totalAmount = 0, totalCharges = 0, processingFeesBreakUp = {}, stepResponseObject, showOtpConfirmation = false, minAmount, maxAmount, showLessLimit = false, mfPortfolioArray, pledgeInProgress = false, term, interestRate, interestAmount, lenderInfo, autoDebitDate, user, stateDutyStamp, isTata, processingFee, lenderId, processingFeeObject, isBajaj, showNewFlow, loanTenureInMonths, showNewVerifyAndInterestFlow, height, contactUsDetails, isZypePlatform, isFromJupiter, allowDynamicLimitFromBEFlag, minimumEligibleLimit) => {
    return {
        layout: {
            id: ROUTE.PLEDGE_CONFIRMATION,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: (showNewVerifyAndInterestFlow && !isZypePlatform) && true,
            },
            widgets: (showNewVerifyAndInterestFlow && !isZypePlatform) ? [
                {
                    id: 'verifyAndInterestScreen',
                    type: WIDGET.VERIFY_AND_INTEREST_SCREEN,
                }
            ] : [
                {
                    id: "customHeader",
                    type: WIDGET.CUSTOM_HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                ...(showLessLimit
                    ? [
                        {
                            id: 'showLessLimitCard',
                            type: WIDGET.CARD,
                            position: POSITION.ABSOLUTE_TOP,
                        },
                        {
                            id: 'continueSpace',
                            type: WIDGET.SPACE,
                            position: POSITION.ABSOLUTE_BOTTOM,
                        },
                    ]
                    : []),
                {
                    id: 'topStackForStyle1',
                    type: WIDGET.STACK,
                    padding: {
                        top: -16,
                        horizontal: -16,
                    }
                },
                {
                    id: 'selectedLimit',
                    type: WIDGET.STACK,
                    padding: {
                        horizontal: -16,
                    }
                },
                {
                    id: 'topStackForStyle2',
                    type: WIDGET.STACK,
                    padding: {
                        horizontal: -16,
                    }
                },
                {
                    id: 'iconCardStack',
                    type: WIDGET.CARD,
                    padding: {
                        horizontal: -16,
                        top: -12,
                    },
                },
                { id: 'continueSpace2', type: WIDGET.SPACE },
                { id: 'interestOptions', type: WIDGET.STACK },
                { id: 'bottomStackForStyle', type: WIDGET.STACK },
                {
                    id: "DividerStack",
                    type: WIDGET.DIVIDER,
                    position: POSITION.ABSOLUTE_BOTTOM,
                    padding: {
                        horizontal: -16
                    }
                },
                { id: 'space1', type: WIDGET.SPACE, position: POSITION.STICKY_BOTTOM },
                ...(showOtpConfirmation && !showNewFlow
                    ? [
                        {
                            id: 'otpConfirmInfo',
                            type: WIDGET.CARD,
                            position: POSITION.STICKY_BOTTOM,
                        },
                    ]
                    : []),
                ...(pledgeInProgress
                    ? [
                        {
                            id: 'showPledgeInProgressCard',
                            type: WIDGET.CARD,
                            position: POSITION.STICKY_BOTTOM,
                        },
                    ]
                    : []),
                {
                    id: 'ctaCard',
                    type: WIDGET.CARD,
                    padding: {
                        horizontal: 0,
                        all: 0,
                    },
                    position: POSITION.STICKY_BOTTOM,
                },
            ],
        },
        datastore: {
            verifyAndInterestScreen: {
                height,
                contactUsDetails,
                creditLineAmount: await SharedPropsService.getCreditLimit(),
                interestRate,
                loanTenureInMonths,
                lenderIcon: getLenderIcon(lenderInfo?.lenderAccountId),
                processingFee,
                foreclosureLabel: 'Free',
                stateDutyStamp,
                goBackAction: {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    type: ACTION.BACK_BUTTON,
                    payload: {}
                },
                stateSelectionAction: {
                    type: ACTION.GO_TO_STATE_SELECTION_PAGE,
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    payload: {
                        stateDutyStamp: stateDutyStamp
                    }
                },
                kfsAction: {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    type: ACTION.GO_TO_KFS,
                    payload: {}
                },
                processingFeeObject,
                lenderInfo,
                continueAction: {
                    type: ACTION.ACTIVATE_PLEDGE,
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    payload: {
                        value: stepResponseObject,
                        widgetId: 'ctaButton',
                        isResend: false,
                        portFolioArray: mfPortfolioArray,
                        lenderId: lenderId
                    },
                },
                trackInterestAndChargesCustomer: {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    type: ACTION.TRACK_CUSTOMER,
                    payload: {}
                },
                isFromJupiter: isFromJupiter
            },
            showPledgeInProgressCard: {
                bgColor: ColorTokens.Secondary_05,
                width: StackWidth.FULL,
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                    left: SizeTypeTokens.LG,
                    right: SizeTypeTokens.LG,
                },
                bodyOrientation: CardOrientation.HORIZONTAL,
                body: {
                    widgetItems: [
                        { id: 'infoIcon3', type: WIDGET.ICON },
                        { id: 'infoIconSpace3', type: WIDGET.SPACE },
                        { id: 'infoLabel3', type: WIDGET.TEXT },
                    ],
                },
            },
            infoIcon3: {
                name: IconTokens.InfoFilled,
                color: ColorTokens.Secondary_100,
            },
            infoIconSpace3: { size: SizeTypeTokens.Size10 },
            continueSpace2: { size: SizeTypeTokens.LG },
            infoLabel3: {
                label: _isMobile ? `Rs. ${addCommasToNumber(stepResponseObject.approvedCreditAmount)} were pledged successfully. We require 1 OTP to\npledge remaining portfolio.` :
                    `Rs. ${addCommasToNumber(stepResponseObject.approvedCreditAmount)} were pledged successfully. We require 1 OTP to pledge remaining portfolio.`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontColor: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            },
            showLessLimitCard: {
                bgColor: ColorTokens.Red_10,
                width: StackWidth.FULL,
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                    left: SizeTypeTokens.LG,
                    right: SizeTypeTokens.LG,
                },
                bodyOrientation: CardOrientation.HORIZONTAL,
                body: {
                    widgetItems: [
                        { id: 'infoIcon2', type: WIDGET.ICON },
                        { id: 'infoIconSpace2', type: WIDGET.SPACE },
                        { id: 'infoLabel2', type: WIDGET.TEXT },
                    ],
                },
            },
            infoIcon2: {
                name: IconTokens.InfoFilled,
                color: ColorTokens.Red_50,
            },
            infoIconSpace2: { size: SizeTypeTokens.Size10 },
            continueSpace: { size: SizeTypeTokens.LG },
            infoLabel2: {
                label: allowDynamicLimitFromBEFlag && minimumEligibleLimit?.nonEligibleDisplayReason
                    ? `${minimumEligibleLimit?.nonEligibleDisplayReason}`
                    : `Minimum amount required to proceed is ₹${addCommasToNumber(getMinAllowedAmountBasedOnLender(lenderId))}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontColor: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            },
            otpConfirmInfo: {
                bgColor: ColorTokens.Secondary_05,
                width: StackWidth.FULL,
                margin: {
                    horizontal: SizeTypeTokens.XL,
                },
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                    left: SizeTypeTokens.LG,
                    right: SizeTypeTokens.LG,
                },
                bodyOrientation: CardOrientation.HORIZONTAL,
                body: {
                    widgetItems: [
                        { id: 'infoIcon', type: WIDGET.ICON },
                        { id: 'infoIconSpace', type: WIDGET.SPACE },
                        showNewFlow ? {} : { id: 'infoLabel', type: WIDGET.TEXT },
                    ],
                },
            },
            infoIcon: {
                name: IconTokens.InfoFilled,
                color: ColorTokens.Secondary_100,
            },
            infoIconSpace: { size: SizeTypeTokens.Size10 },
            infoLabel: {
                label: 'We will trigger 2 OTPs to confirm your pledge',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontColor: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            },
            space0: { size: SizeTypeTokens.SM },
            contactUsSpace: { size: SizeTypeTokens.SM },
            selectedLimit: {
                padding: { top: SizeTypeTokens.XL, bottom: SizeTypeTokens.XL, left: SizeTypeTokens.XL, right: SizeTypeTokens.XL },
                width: StackWidth.MATCH_PARENT,
                type: StackType.column,
                isDarkMode: isDarkMode ? true : false,
                alignItems: StackAlignItems.flexStart,
                bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White,
                widgetItems: [
                    { id: 'selectedLimitText', type: WIDGET.TEXT },
                    { id: 'space1', type: WIDGET.SPACE },
                    { id: 'selectedLimitValue', type: WIDGET.STACK },
                    { id: 'spaceXL', type: WIDGET.SPACE },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'spaceXL', type: WIDGET.SPACE },
                    { id: 'selectedLimitText2', type: WIDGET.TEXT },
                    { id: 'spaceSize2', type: WIDGET.SPACE },
                    { id: 'selectedLimitValue2', type: WIDGET.STACK },
                    { id: 'spaceXL', type: WIDGET.SPACE },
                ],
            },
            selectedLimitText: {
                label: 'Selected credit limit',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
                lineHeight: 20
            },
            space1: { size: SizeTypeTokens.Size6 },
            selectedLimitValue: {
                type: StackType.row,
                alignItems: StackAlignItems.baseline,
                widgetItems: [
                    { id: 'ruppee', type: WIDGET.TEXT },
                    { id: 'selectedLimitValueText', type: WIDGET.TEXT },
                ],
            },
            ruppee: {
                label: '₹',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                fontSize: FontSizeTokens.XXXXL,
                color: ColorTokens.Secondary_100,
                lineHeight: 32
            },
            selectedLimitValueText: {
                id: 'txt_confirmPledge_selectedCreditLimit',
                label: `${addCommasToNumber(await SharedPropsService.getCreditLimit())}`,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '900',
                fontSize: FontSizeTokens.XXXXL,
                color: ColorTokens.Secondary_100,
            },
            space: { size: SizeTypeTokens.XL },
            divider: {
                size: DividerSizeTokens.SM,
                color: isDarkMode ? ColorTokens.DARK_MODE_DIVIDER : ColorTokens.Grey_Chalk,
            },
            space3: { size: SizeTypeTokens.Size6 },
            selectedLimitText2: {
                label: 'Selected mutual funds',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18
            },
            selectedLimitValue2: {
                type: StackType.row,
                alignItems: StackAlignItems.baseline,
                widgetItems: [
                    { id: 'selectedLimitValueText3', type: WIDGET.TEXT },
                    { id: 'selectedLimitValueText4', type: WIDGET.TEXT },
                ],
            },
            selectedLimitValueText3: {
                id: 'txt_confirmPledge_selectedMutualFunds',
                label: `₹${addCommasToNumber(parseInt(await SharedPropsService.getDesiredPortfolio()))}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                fontSize: FontSizeTokens.MD,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                lineHeight: 24
            },
            selectedLimitValueText4: {
                label: ` out of ₹${addCommasToNumber(parseInt(stepResponseObject['totalPortfolioAmount'].toString()))}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
            },
            processingFeeDropDown: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    bottom: SizeTypeTokens.LG,
                    right: SizeTypeTokens.XXXL
                },
                widgetItems: createProcessingChargeDS(processingFeeObject).WIDGET_ITEMS
            },
            ...createProcessingChargeDS(processingFeeObject).DATA_STORE,
            spaceSize6: {
                size: SizeTypeTokens.XXXL,
            },
            processingText: {
                label: 'Processing fee',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 24,
            },
            processingValue: {
                label: `₹1000`,
                fontSize: FontSizeTokens.MD,
                marginRight: 8,
                color: ColorTokens.Grey_Charcoal,
            },
            processingGSTText: {
                label: 'GST @18%',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 24,
            },
            processingGSTValue: {
                label: `₹180`,
                fontSize: FontSizeTokens.MD,
                marginRight: 8,
                color: ColorTokens.Grey_Charcoal,
            },
            processingCard: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                width: StackWidth.MATCH_PARENT,
                flex: 1,
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XXXXXL,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardText', type: WIDGET.TEXT },
                ],
            },
            interestRateS1: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'interestRateT1', type: WIDGET.TEXT },
                ],
            },
            interestRateS2: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'interestRateT2', type: WIDGET.TEXT },
                ],
            },
            interestAutoPayS1: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'interestAutoPayT1', type: WIDGET.TEXT },
                ],
            },
            interestAutoPayS2: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'interestAutoPayT2', type: WIDGET.TEXT },
                ],
            },
            termTextStack2: {
                height: StackHeight.CONTENT,
                type: StackType.row,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'termText2', type: WIDGET.TEXT },
                ],
            },
            withdrawalS1: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'withdrawalT1', type: WIDGET.TEXT },
                ],
            },
            withdrawalS2: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'withdrawalT2', type: WIDGET.TEXT },
                ],
            },
            termAccordionMainstack: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                borderRadius: 4,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'termAccordionStack', type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            termAccordionStack: {
                height: StackHeight.CONTENT,
                type: StackType.column,
                flex: 1,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'termCard', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: "termTextStack2", type: WIDGET.STACK },
                    { id: 'space3', type: WIDGET.SPACE },
                ],
            },
            termCard: {
                height: StackHeight.CONTENT,
                type: StackType.row,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'termT1', type: WIDGET.TEXT },
                ],
            },
            foreclosureDropDownAccordion: {
                type: StackType.row,
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'foreclosureCard', type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            foreclosureCard: {
                height: StackHeight.CONTENT,
                flex: 1,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'foreClosureT1', type: WIDGET.TEXT },
                ],
            },
            interestRateAccordion: {
                width: StackWidth.FULL,
                type: StackType.row,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'interestRateCard', type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            interestRateCard: {
                height: StackHeight.CONTENT,
                type: StackType.column,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'interestRateS1', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: 'interestRateS2', type: WIDGET.STACK },
                    { id: 'space3', type: WIDGET.SPACE },
                ],
            },
            interestAutoPayAccordion: {
                width: StackWidth.FULL,
                type: StackType.row,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'interestAutoPayCard', type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            interestAutoPayCard: {
                height: StackHeight.CONTENT,
                flex: 1,
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'interestAutoPayS1', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: 'interestAutoPayS2', type: WIDGET.STACK },
                    { id: 'space3', type: WIDGET.SPACE },
                ],
            },
            withdrawalDropDownAccordion: {
                width: StackWidth.FULL,
                type: StackType.row,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'withdrawalCard', type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            withdrawalCard: {
                height: StackHeight.CONTENT,
                flex: 1,
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'withdrawalS1', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: 'withdrawalS2', type: WIDGET.STACK },
                    { id: 'space3', type: WIDGET.SPACE },
                ],
            },
            pCardIcon: {
                name: IconTokens.CoveredRightArrow,
                size: IconSizeTokens.SM,
                align: IconAlignmentTokens.center,
                color: ColorTokens.Grey_Charcoal,
            },
            pCardText: {
                label: 'One-time processing fee, no hidden charges',
                color: isDarkMode && ColorTokens.White,
                fontSize: FontSizeTokens.XS,
            },
            interestRateT1: {
                label: 'Interest charged only on usage',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            interestRateT2: {
                label: `Monthly interest of ₹${interestAmount} on withdrawal of ₹10,000`,
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            interestAutoPayT1: {
                label: Platform.OS === 'web'
                    ? 'Interest statement will be generated at the end of month'
                    : 'Interest statement will be generated at the\nend of month',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            interestAutoPayT2: {
                label: Platform.OS === 'web'
                    ? `Hassle-free auto repayment of interest on ${autoDebitDate}`
                    : `Hassle-free auto repayment of interest on
${autoDebitDate}`,
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            termText2: {
                label: 'Renewal can be done easily without repaying\nprincipal',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            withdrawalT1: {
                label: 'Withdraw money as per your convenience',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            withdrawalT2: {
                label: Platform.OS === "ios" ? 'Repay principal amount anytime during the month,\nno prepayment charges.' : 'Repay principal amount anytime during the month, no prepayment charges.',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            termT1: {
                label: `Tenure of the credit line facility is ${loanTenureInMonths} months`,
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            foreClosureT1: {
                label: 'Close your loan anytime without any additional \ncharges or hidden fee.',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            otherChargesStack: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [{ id: 'otherChargesText', type: WIDGET.TEXT }],
            },
            otherChargesText: {
                label: 'Interest & other charges',
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '500',
                fontSize: FontSizeTokens.MD,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            interestAccordion: {
                id: 'acd_confirmPledge_interest',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                isDarkMode: isDarkMode ? true : false,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'interestRateStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'interestRateAccordion',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            autoPayAccordion: {
                id: 'acd_confirmPledge_autoPay',
                icon: IconTokens.DownArrow,
                isDarkMode: isDarkMode ? true : false,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'autoPayStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'interestAutoPayAccordion',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            withdrawalAccordion: {
                id: 'acd_confirmPledge_withdraw',
                icon: IconTokens.DownArrow,
                isDarkMode: isDarkMode ? true : false,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'withdrawalStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'withdrawalDropDownAccordion',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            termAccordion: {
                id: 'acd_confirmPledge_term',
                icon: IconTokens.DownArrow,
                isDarkMode: isDarkMode ? true : false,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'termStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'termAccordionMainstack',
                                    type: WIDGET.STACK,
                                    padding: {
                                        bottom: -12,
                                    },
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            foreClosureAccordion: {
                id: 'acd_confirmPledge_foreClosure',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                isDarkMode: isDarkMode ? true : false,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'foreClosureStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'foreclosureDropDownAccordion',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            loanRegistrationAccordian: {
                id: 'acd_confirmPledge_loanRegistration',
                icon: IconTokens.DownArrow,
                isDarkMode: isDarkMode ? true : false,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'loanRegistrationStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'loanRegistrationDropDownAccordion',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            loanRegistrationDropDownAccordion: {
                type: StackType.row,
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'loanRegistrationCard', type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            loanRegistrationCard: {
                height: StackHeight.CONTENT,
                flex: 1,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                bgColor: isDarkMode ? ColorTokens.Yellow_90 : ColorTokens.Yellow_10,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIconStack', type: WIDGET.STACK },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'loanRegistrationT1Stack', type: WIDGET.STACK },
                ],
            },
            pCardIconStack: {
                position: StackPositionType.relative,
                positionConfig: {
                    top: SizeTypeTokens.XS
                },
                widgetItems: [
                    { id: 'pCardIcon', type: WIDGET.ICON },
                ]
            },
            loanRegistrationT1Stack: {
                type: StackType.column,
                widgetItems: [
                    { id: 'loanRegistrationT1StackT1', type: WIDGET.TEXT },
                    { id: 'loanRegistrationT1Stack2', type: WIDGET.STACK },
                ]
            },
            loanRegistrationT1StackT1: {
                label: `Selected state for loan agreement stamp: ${stateDutyStamp}`,
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            loanRegistrationT1Stack2: {
                type: StackType.row,
                widgetItems: [
                    { id: 'loanRegistrationT1Stack2T1', type: WIDGET.TEXT },
                    { id: 'loanRegistrationT1Stack2T2ClickStack', type: WIDGET.STACK },
                ]
            },
            loanRegistrationT1Stack2T1: {
                label: 'To change the state,',
                fontSize: FontSizeTokens.XS,
            },
            loanRegistrationT1Stack2T2ClickStack: {
                width: StackWidth.CONTENT,
                widgetItems: [
                    { id: 'loanRegistrationT1Stack2T2', type: WIDGET.TEXT }
                ],
                action: {
                    type: ACTION.GO_TO_STATE_SELECTION_PAGE,
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    payload: {
                        stateDutyStamp: stateDutyStamp
                    }
                }
            },
            loanRegistrationT1Stack2T2: {
                label: ' click here',
                fontSize: FontSizeTokens.XS,
                fontWeight: '600',
                color: ColorTokens.Primary_100
            },
            loanRegistrationStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'loanRegistrationText', type: WIDGET.TEXT },
                    { id: 'loanRegistrationType', type: WIDGET.TEXT },
                ],
            },
            loanRegistrationText: {
                label: 'Loan registration state',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            loanRegistrationType: {
                label: `${stateDutyStamp}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 16,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            processingAccordion: {
                id: 'acd_confirmPledge_processing',
                rightIcon: AccordionArrow.LEFT,
                isDarkMode: isDarkMode ? true : false,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'processingStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'processingFeeDropDown',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            spaceXL: { size: SizeTypeTokens.XL },
            interestOptions: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.column,
                widgetItems: [
                    { id: 'otherChargesStack', type: WIDGET.STACK },
                    { id: 'processingAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'interestAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'autoPayAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'withdrawalAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'termAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'foreClosureAccordion', type: WIDGET.ACCORDION },
                    isTata ? { id: 'divider', type: WIDGET.DIVIDER } : {},
                    isTata ? { id: 'loanRegistrationAccordian', type: WIDGET.ACCORDION } : {},
                    isTata ? { id: 'divider', type: WIDGET.DIVIDER } : {},
                    !isBajaj ? { id: 'kfsStack', type: WIDGET.STACK } : {},
                ],
            },
            customHeader: {
                title: showNewFlow ? "Verify interest and charges" : "Confirm pledge",
                needHelpAction: {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_confirmPledge_needHelp' }
                },
                isDarkMode: isDarkMode ? true : false,
                goBackAction: {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    type: ACTION.BACK_BUTTON,
                    payload: { id: 'bt_confirmPledge_goBack' }
                },
            },
            topStackForStyle1: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                bgColor: ColorTokens.Primary_05,
                widgetItems: [
                    { id: 'bottomStackForStyleSpace', type: WIDGET.SPACE }
                ]
            },
            topStackForStyle2: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                bgColor: ColorTokens.Primary_05,
                widgetItems: [
                    { id: 'bottomStackForStyleSpace', type: WIDGET.SPACE }
                ]
            },
            bottomStackForStyle: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                // bgColor: ColorTokens.,
                widgetItems: [
                    { id: 'bottomStackForStyleSpace', type: WIDGET.SPACE }
                ]
            },
            bottomStackForStyleSpace: {
                size: SizeTypeTokens.XXXL
            },
            kfsStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                padding: {
                    top: SizeTypeTokens.XXXL
                },
                justifyContent: StackJustifyContent.spaceBetween,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'kfsStackT1', type: WIDGET.TEXT },
                    { id: 'kfsStackButton', type: WIDGET.BUTTON },
                ]
            },
            kfsStackT1: {
                label: 'For Key fact statement',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 20,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            kfsStackButton: {
                id: 'bt_confirmPledge_clickHere',
                label: 'Click here',
                type: ButtonTypeTokens.SmallGhost,
                width: ButtonWidthTypeToken.CONTENT,
                fontSize: FontSizeTokens.SM,
                action: {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    type: ACTION.GO_TO_KFS,
                    payload: {}
                }
            },
            processingMainStack: {
                width: StackWidth.FULL,
                type: StackType.column,
            },
            processingStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'processingFeeText', type: WIDGET.TEXT },
                    { id: 'processingFeeValue', type: WIDGET.TEXT },
                ],
            },
            processingFeeText: {
                label: 'Total charges (excl. of GST)',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            processingFeeValue: {
                label: `₹${addCommasToNumber(Number(processingFee))}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                marginRight: 20,
            },
            spaceLG: { size: SizeTypeTokens.LG },
            interestRateStack: {
                type: StackType.row,
                width: StackWidth.FULL,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'interestRateText', type: WIDGET.TEXT },
                    { id: 'interestRateValue', type: WIDGET.TEXT },
                ],
            },
            interestRateText: {
                label: 'Interest rate',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            interestRateValue: {
                label: `${interestRate}%`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                marginRight: 20,
            },
            autoPayStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'autoPayText', type: WIDGET.TEXT },
                    { id: 'autoPayValue', type: WIDGET.TEXT },
                ],
            },
            autoPayText: {
                label: 'Interest autopay',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            autoPayValue: {
                label: `${autoDebitDate}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            withdrawalStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'withdrawalText', type: WIDGET.TEXT },
                    { id: 'withdrawalType', type: WIDGET.TEXT },
                ],
            },
            termStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'termText', type: WIDGET.TEXT },
                    { id: 'durationValue', type: WIDGET.TEXT },
                ],
            },
            foreClosureStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'foreClosureText', type: WIDGET.TEXT },
                    { id: 'foreClosureType', type: WIDGET.TEXT },
                ],
            },
            durationText: {
                label: 'Duration',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            withdrawalText: {
                label: 'Withdrawal & repayment',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            downArrow: {
                name: IconTokens.ChevronDown,
                align: IconAlignmentTokens.center,
                color: isDarkMode && ColorTokens.White
            },
            termText: {
                label: 'Term',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            foreClosureText: {
                label: 'Foreclosure',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            durationValue: {
                label: `${loanTenureInMonths} months (with renewal)`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            withdrawalType: {
                label: 'Flexi',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            foreClosureType: {
                label: lenderInfo?.lenderAccountId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() ? 'Nil.' : 'Free',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 16,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
            },
            iconStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                justifyContent: StackJustifyContent.spaceBetween,
                bgColor: isDarkMode ? ColorTokens.Grey_Charcoal : ColorTokens.Secondary_Milk,
                alignItems: StackAlignItems.center,
                padding: {
                    top: SizeTypeTokens.MD,
                    bottom: SizeTypeTokens.MD,
                },
                widgetItems: [
                    { id: 'lendingTXT', type: WIDGET.TEXT },
                    lenderInfo?.lenderAccountId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()
                        ? { id: 'bajajImage', type: WIDGET.ICON }
                        : { id: 'bajaj', type: WIDGET.ICON }
                ],
            },
            bajajImage: {
                name: IconTokens.BAJAJ_FULL_LOGO_NEW
            },
            lendingTXT: {
                label: 'LENDING PARTNER',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                color: isDarkMode && ColorTokens.White
            },
            space11: { size: SizeTypeTokens.MD },
            bajaj: {
                name: getLenderIcon(lenderInfo?.lenderAccountId)
            },
            spaceMD: { size: SizeTypeTokens.SM },
            ctaText: {
                label: 'Total amount',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            portfolioTitle: {
                label: 'Processing fee (incl. GST)',
                fontFamily: FontFamilyTokens.Poppins,
                color: ColorTokens.Grey_Night,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                lineHeight: 24,
            },
            //portfolioCard
            portfolioCard: {
                label: 'Check portfolio credit limit',
                fontFamily: FontFamilyTokens.Poppins,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
            },
            iconCardStack: {
                alignItems: StackAlignItems.center,
                bgColor: isDarkMode ? ColorTokens.Grey_Charcoal : ColorTokens.Grey_Milk,
                justifyContent: StackJustifyContent.spaceBetween,
                body: {
                    widgetItems: [{ id: 'iconCard', type: WIDGET.STACK }],
                },
            },
            iconCard: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: 'space9', type: WIDGET.SPACE },
                    { id: 'iconStack', type: WIDGET.STACK },
                    { id: 'space9', type: WIDGET.SPACE },
                ],
            },
            space9: { size: SizeTypeTokens.Size6 },
            ctaCard: {
                bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White,
                body: { widgetItems: [{ id: 'ctaBody', type: WIDGET.STACK }] },
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.Size10,
                    bottom: SizeTypeTokens.SIZE18,
                },
            },
            ctaBody: {
                width: StackWidth.FULL,
                type: StackType.column,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    {
                        id: 'ctaButton',
                        type: WIDGET.BUTTON,
                    },
                ],
            },
            ctaButton: {
                id: 'bt_confirmPledge_continue',
                label: showNewFlow ? "Continue" : 'Continue to get OTP',
                fontWeight: '700',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                type: showLessLimit
                    ? ButtonTypeTokens.LargeOutline
                    : ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: showNewFlow ? ACTION.ACTIVATE_PLEDGE : ACTION.SEND_OTP_FOR_PLEDGE_CONFIRM,
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    payload: {
                        value: stepResponseObject,
                        widgetId: 'ctaButton',
                        isResend: false,
                        portFolioArray: mfPortfolioArray,
                        lenderId: lenderId
                    },
                },
            },
            spaceCard: { size: SizeTypeTokens.LG },
            spaceSize2: {
                size: SizeTypeTokens.XS
            },
            DividerStack: {
                size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk
            },
        },
    };
};
export const pledgeConfirmationMFV2 = {
    onLoad: async ({ instrumentTrack, network, setDatastore, getHeight }, { stepResponseObject, skipPledgeInProgressCheck = false }) => {
        let pledgeInProgress = skipPledgeInProgressCheck;
        let mfPortfolioArray = [];
        let portfolioForComputingProcessingCharge;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === 'JUPITER';
        let user;
        let isZypePlatform = false;
        if (Platform.OS === "web") {
            const params = getParameters(window.location.href);
            isZypePlatform = params?.platform === "ZYPE";
        }
        const showNewVerifyAndInterestFlow = await showNewInterestFlow();
        const contactUsDetails = await getContactUsDetails();
        if (await AsyncStorage.getItem("application_id")) {
            user = await SharedPropsService.getUser();
        }
        else {
            const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
            user = userContextResponse.data;
        }
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = (await SharedPropsService.getUser())
                .linkedApplications[0].applicationId;
        }
        const pledgeData = await network.get(`${api.pledgeLimit}${applicationId}`, {
            headers: await getAppHeader(),
        });
        const lenderId = pledgeData?.data?.updatedApplicationObj?.lenderAccountId;
        const isTata = lenderId?.toLowerCase() === LENDER_ID.TATA.toLowerCase();
        const isBajaj = lenderId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
        let stateDutyStamp = '';
        instrumentTrack("LOAN_SUMMARY_PAGE_VIEWED", { "credit_limit": `${addCommasToNumber(await SharedPropsService.getCreditLimit())}`, "portfolio_pledge": `${addCommasToNumber(parseInt(await SharedPropsService.getDesiredPortfolio()))}` });
        // call pledge limit api if stepResponseObject is null
        if (stepResponseObject === undefined || stepResponseObject === null) {
            pledgeInProgress = !skipPledgeInProgressCheck;
            const authCAS = await SharedPropsService.getAuthCASResponse();
            const pledgeLimitResponse = authCAS
                ? { data: authCAS }
                : await network
                    .get(`${api.pledgeLimit}${applicationId}`, {
                    headers: await getAppHeader(),
                })
                    .then(response => ({
                    data: response.data,
                }));
            stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        }
        const loanTenureInMonths = stepResponseObject?.loanTenureInMonths;
        if (!pledgeInProgress) {
            mfPortfolioArray = stepResponseObject
                .availableCAS;
            mfPortfolioArray.forEach((_item, index) => {
                mfPortfolioArray[index].is_pledged = _item.pledgedUnits > 0;
            });
            portfolioForComputingProcessingCharge = mfPortfolioArray;
        }
        else {
            mfPortfolioArray = stepResponseObject
                .tobePledgedPortfolio;
            portfolioForComputingProcessingCharge = [...mfPortfolioArray];
            portfolioForComputingProcessingCharge.push(...stepResponseObject.pledgedPortfolio);
        }
        await SharedPropsService.setToBePledgedAssets(mfPortfolioArray);
        /// fetch processing fee
        const response = await network.post(api.processingCharges, {
            applicationId: applicationId,
            mutualFundPortfolioItems: portfolioForComputingProcessingCharge,
        }, { headers: await getAppHeader() });
        const processingFee = response?.data?.stepResponseObject?.totalCharges;
        const processingFeeObject = response?.data?.stepResponseObject?.processingChargesBreakup;
        stateDutyStamp = pledgeData?.data?.stepResponseObject?.stampDutyState;
        const requestedCreditAmount = pledgeData?.data?.stepResponseObject?.requestedCreditAmount;
        if (requestedCreditAmount) {
            const stampDutyChargesResponse = await network.get(`${api.getStampDutyCharges}${requestedCreditAmount}`, {
                headers: await getAppHeader()
            });
            if (stampDutyChargesResponse.status === 200) {
                await SharedPropsService.setStampDutyData(stampDutyChargesResponse?.data);
            }
        }
        const portValue = getDesiredValue(mfPortfolioArray, stepResponseObject.isinNAVMap);
        const desiredLimit = getTotalLimit(mfPortfolioArray, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap);
        const totalAmount = getTotalLimit(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap);
        const totalCreditAmount = roundDownToNearestHundred(totalAmount);
        if (pledgeInProgress) {
            await SharedPropsService.setCreditLimit(desiredLimit);
        }
        const interestRate = _.get(pledgeData, 'data.stepResponseObject.interestRate');
        const term = _.get(pledgeData, 'data.stepResponseObject.loanTenureInMonths');
        await SharedPropsService.setDesiredPortfolio(portValue);
        const processingFeesBreakUp = _.get(response, 'data.stepResponseObject.processingChargesBreakup', {});
        const totalCharges = _.get(response, 'data.stepResponseObject.totalCharges', 0);
        await updateApplicationContextFromApi(network, applicationId);
        const updateUser = await SharedPropsService.getUser();
        const assetPledgeExists = "ASSET_PLEDGE" in updateUser.linkedApplications[0].stepStatusMap;
        const assetTypeMap = {};
        /*** check unique asset type */
        mfPortfolioArray.forEach(item => {
            if (item.is_pledged)
                assetTypeMap[item.assetRepository] = true;
        });
        /*** show 2 otp confirmation if both Karvy and CAMS is present */
        const showOtpConfirmation = Object.keys(assetTypeMap).length > 1;
        const minAmount = await SharedPropsService.getConfig(ConfigTokens.MIN_AMOUNT_ALLOWED);
        const maxAmount = await SharedPropsService.getConfig(ConfigTokens.MAX_AMOUNT_ALLOWED);
        let showLessLimit;
        const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
        //@ts-ignore
        const minimumAmount = minimumEligibleLimit?.amount !== undefined ? minimumEligibleLimit?.amount : minimumEligibleLimitAmount;
        const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
        if (!pledgeInProgress) {
            if (allowDynamicLimitFromBEFlag) {
                (typeof totalCreditAmount === 'number' && totalCreditAmount < minimumAmount)
                    ? (showLessLimit = true)
                    : (showLessLimit = false);
            }
            else {
                (await SharedPropsService.getCreditLimit()) < getMinAllowedAmountBasedOnLender(lenderId)
                    ? (showLessLimit = true)
                    : (showLessLimit = false);
            }
        }
        const lenderInfo = await getLenderInfo(network);
        const interestAmount = Math.floor((10000 * interestRate) / 1200);
        const autoDebitDate = await getAutoDebitDate(network);
        return Promise.resolve(template(totalAmount, totalCharges, processingFeesBreakUp, stepResponseObject, showOtpConfirmation, minAmount, maxAmount, showLessLimit, mfPortfolioArray, pledgeInProgress, term, interestRate, interestAmount, lenderInfo, autoDebitDate, user, stateDutyStamp, isTata, processingFee, lenderId, processingFeeObject, isBajaj, assetPledgeExists, loanTenureInMonths, showNewVerifyAndInterestFlow, getHeight(), contactUsDetails, isZypePlatform, isFromJupiter, allowDynamicLimitFromBEFlag, minimumEligibleLimit));
    },
    actions: {
        [ACTION.NAV_TO_FAQ]: goToFaq,
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.SEND_OTP_FOR_PLEDGE_CONFIRM]: sendOtpForPledgeConfirm,
        [ACTION.ACTIVATE_PLEDGE]: activateAsset,
        [ACTION.ON_PAGE_LOAD]: onLoad,
        [ACTION.GO_TO_KFS]: goToKfs,
        [ACTION.GO_TO_STATE_SELECTION_PAGE]: goToStateSelectionPage,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.TRACK_CUSTOMER]: trackInterestAndChargesCustomer,
    },
    action: {
        type: ACTION.ON_PAGE_LOAD,
        routeId: ROUTE.PLEDGE_CONFIRMATION,
        payload: {},
    },
    clearPrevious: true,
};
